import styled from 'styled-components'

interface SpinnerIconLoaderProps {
  size: number
  velocity: number
}

export const SpinnerComponent = styled.div<SpinnerIconLoaderProps>`
  position: relative;
  width: ${props => props.size}px;
  height: ${props => props.size}px;

  animation: rotating ${props => props.velocity}s linear infinite;

  * {
    width: ${props => props.size}px;
    height: ${props => props.size}px;
  }

  @keyframes rotating {
    from {
      transform: rotate(0deg);
    }
    to {
      transform: rotate(360deg);
    }
  }
`
